import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useBootstrap } from "./useBootstrap";
import { bootstrapQueryKey } from "./bootstrapQuery";
import { updateSettings } from "@/api/users.api";

export function useUpdateSettings() {
  const queryClient = useQueryClient();
  const { data: user } = useBootstrap();

  const queryKey = bootstrapQueryKey(user?._id);

  const mutation = useMutation({
    mutationFn: updateSettings,
    onMutate: async (newFields) => {
      await queryClient.cancelQueries({ queryKey });

      const previousData = queryClient.getQueryData(queryKey);

      queryClient.setQueryData(queryKey, (old) => ({
        ...old,
        ...newFields,
      }));

      return { previousData };
    },
    onSuccess: (updatedUser) => {
      queryClient.setQueryData(queryKey, (prev) => {
        const {
          count,
          dataUse,
          wellnesstimer,
          voice,
          displayName,
          maxDayStreak,
          maxWeekStreak,
          curDayStreak,
          curWeekStreak,
          coins,
          adultActionImages,
          usesCastle,
          badges,
          receiveAlerts,
          receiveEmailAlerts,
          receiveReports,
          needsOnboarding,
        } = updatedUser;
        return {
          ...prev,
          ...{
            count,
            dataUse,
            wellnesstimer,
            voice,
            displayName,
            maxDayStreak,
            maxWeekStreak,
            curDayStreak,
            curWeekStreak,
            coins,
            adultActionImages,
            usesCastle,
            badges,
            receiveAlerts,
            receiveEmailAlerts,
            receiveReports,
            needsOnboarding,
          },
        };
      });
    },
    onError: (_error, _newFields, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(queryKey, context.previousData);
      }
    },
  });

  return {
    updateSettings: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
